import React, { useState, useEffect } from "react";
import { useAuth } from "../../../usercontext";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
import StudentCollegeList from "./CollegeList";
import StudentHeader from "../header";

export default function StudentCollegeListIndex() {
  const { profile } = useAuth();
  const slug = profile.id;
  const isStudent12 = profile?.role === "Student12";
  const isStudent = profile?.role === "Student";
  // const [mobileMenu, setMobileMenu] = useState(false)
  return (
    <>
    {/* <StudentHeader mobileMenu={mobileMenu} setMobileMenu={setMobileMenu}/> */}
      {isStudent && <STopMenu slug={slug} activeMenu="StudentCollegeListIndex" />}
      {isStudent12 && <S12TopMenu slug={slug} activeMenu="StudentCollegeListIndex" />}
      <StudentCollegeList slug={slug} isStudent={true} />
    </>
  );
}
